export const AREA_PAGE_FOURTH_MAP_CARD_FLAG = 'area-page-fourth-map-card';
export const RECENTLY_SOLD_NAV_LINK_FLAG = 'nav-recently-sold-link-update';
export const MAP_SINGLE_LISTING_PREVIEW_FLAG = 'map-single-cluster-experiment';
export const NEW_HEADER_FLAG = 'use-new-navigation-menu';
export const MAINTENANCE_BANNER_FLAG = 'scheduled-maintenance-banner';
export const FEEDBACK_BANNER_FLAG = 'feedback-survey-banner';
export const SOLD_LISTING_PVR_VS_HOME_ESTIMATE_FLAG = 'sold-listing-PVR-vs-home-estimate';
export const AGENT_PROFILE_TRANSLATION_FLAG = 'agent-profile-translation';
export const PROVIDER_DISCLAIMER_TRANSLATION_FLAG = 'provider-disclaimer-translation';
export const SMART_CHATBOT_EXPERIMENT_FLAG = 'smart-chatbot-experiment';

/**
 * Section visibility flags
 * 
 * Format: section-{sectionId}
 * Values: 'v1' | 'v2' | 'hidden' (or null to use tenant default)
 * 
 * These flags allow GrowthBook to override tenant section configs for experiments.
 * @see docs/guides/section-pattern.md
 */
export const SECTION_FLAG_PREFIX = 'section-';

/**
 * Generates a feature flag key for a section
 * @param sectionId - The section identifier (e.g., 'address-hero', 'sticky-footer')
 * @returns The feature flag key (e.g., 'section-address-hero')
 */
export function getSectionFeatureFlag(sectionId: string): string {
  return `${SECTION_FLAG_PREFIX}${sectionId}`;
}

/**
 * Known section IDs for type safety and documentation
 */
export const SECTION_IDS = {
  ADDRESS_HERO: 'address-hero',
  STICKY_FOOTER: 'sticky-footer',
} as const;

/**
 * Layout-level feature flags
 * 
 * These allow GrowthBook to override entire page layouts.
 * Format: layout-{pageId}-{viewport}
 * Values: 'v1' | 'v2' (or null to use tenant default)
 */
export const LAYOUT_FLAG_PREFIX = 'layout-';

export const LAYOUT_FLAGS = {
  /** Address page layout for mobile viewport */
  ADDRESS_PAGE_MOBILE: 'layout-address-page-mobile',
  /** Address page layout for desktop viewport */
  ADDRESS_PAGE_DESKTOP: 'layout-address-page-desktop',
} as const;

/**
 * Redesign experiment flags
 * 
 * Used for A/B testing new component designs.
 * These keys must match the experiment keys in GrowthBook.
 */
export const REDESIGN_FLAGS = {
  /** Listing page hero redesign experiment */
  LISTING_HERO: 'dj-listing-hero-redesign',
} as const;

export type RedesignFlagKey = keyof typeof REDESIGN_FLAGS;
